"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitingFor = void 0;
var vue_1 = require("vue");
var AndOptions_1 = require("./AndOptions");
var OrOptions_1 = require("./OrOptions");
var PlayerInputFactory_1 = require("./PlayerInputFactory");
var SelectAmount_1 = require("./SelectAmount");
var SelectCard_1 = require("./SelectCard");
var SelectHowToPay_1 = require("./SelectHowToPay");
var SelectHowToPayForProjectCard_1 = require("./SelectHowToPayForProjectCard");
var SelectInitialCards_1 = require("./SelectInitialCards");
var SelectOption_1 = require("./SelectOption");
var SelectPlayer_1 = require("./SelectPlayer");
var SelectSpace_1 = require("./SelectSpace");
var i18n_1 = require("../directives/i18n");
var SelectPartyPlayer_1 = require("./SelectPartyPlayer");
var SelectPartyToSendDelegate_1 = require("./SelectPartyToSendDelegate");
var PreferencesManager_1 = require("./PreferencesManager");
var SoundManager_1 = require("./SoundManager");
var SelectColony_1 = require("./SelectColony");
var SelectProductionToLose_1 = require("./SelectProductionToLose");
var ShiftAresGlobalParameters_1 = require("./ShiftAresGlobalParameters");
var constants = require("../constants");
var ui_update_timeout_id;
var documentTitleTimer;
exports.WaitingFor = vue_1.default.component('waiting-for', {
    props: {
        player: {
            type: Object,
        },
        players: {
            type: Array,
        },
        settings: {
            type: Object,
        },
        waitingfor: {
            type: Object,
        },
    },
    data: function () {
        return {
            waitingForTimeout: this.settings.waitingForTimeout,
        };
    },
    components: {
        'and-options': AndOptions_1.AndOptions,
        'or-options': OrOptions_1.OrOptions,
        'select-amount': SelectAmount_1.SelectAmount,
        'select-card': SelectCard_1.SelectCard,
        'select-option': SelectOption_1.SelectOption,
        'select-how-to-pay': SelectHowToPay_1.SelectHowToPay,
        'select-how-to-pay-for-project-card': SelectHowToPayForProjectCard_1.SelectHowToPayForProjectCard,
        'select-initial-cards': SelectInitialCards_1.SelectInitialCards,
        'select-player': SelectPlayer_1.SelectPlayer,
        'select-space': SelectSpace_1.SelectSpace,
        'select-party-player': SelectPartyPlayer_1.SelectPartyPlayer,
        'select-party-to-send-delegate': SelectPartyToSendDelegate_1.SelectPartyToSendDelegate,
        'select-colony': SelectColony_1.SelectColony,
        'select-production-to-lose': SelectProductionToLose_1.SelectProductionToLose,
        'shift-ares-global-parameters': ShiftAresGlobalParameters_1.ShiftAresGlobalParameters,
    },
    methods: {
        animateTitle: function () {
            var sequence = '\u25D1\u25D2\u25D0\u25D3';
            var first = document.title[0];
            var position = sequence.indexOf(first);
            var next = sequence[0];
            if (position !== -1 && position < sequence.length - 1) {
                next = sequence[position + 1];
            }
            document.title = next + ' ' + i18n_1.$t(constants.APP_NAME);
        },
        waitForUpdate: function () {
            var _this = this;
            var vueApp = this;
            var root = this.$root;
            clearTimeout(ui_update_timeout_id);
            var askForUpdate = function () {
                var xhr = new XMLHttpRequest();
                xhr.open('GET', '/api/waitingfor' + window.location.search + '&gameAge=' + _this.player.game.gameAge + '&undoCount=' + _this.player.game.undoCount);
                xhr.onerror = function () {
                    root.showAlert('Unable to reach the server. The server may be restarting or down for maintenance.', function () { return vueApp.waitForUpdate(); });
                };
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        var result = xhr.response;
                        if (result.result === 'GO') {
                            root.updatePlayer();
                            if (Notification.permission !== 'granted') {
                                Notification.requestPermission();
                            }
                            else if (Notification.permission === 'granted') {
                                new Notification(constants.APP_NAME, {
                                    icon: '/favicon.ico',
                                    body: 'It\'s your turn!',
                                });
                            }
                            var soundsEnabled = PreferencesManager_1.PreferencesManager.load('enable_sounds') === '1';
                            if (soundsEnabled)
                                SoundManager_1.SoundManager.playActivePlayerSound();
                            return;
                        }
                        else if (result.result === 'REFRESH') {
                            root.updatePlayer();
                            return;
                        }
                        vueApp.waitForUpdate();
                    }
                    else {
                        root.showAlert("Received unexpected response from server (" + xhr.status + "). This is often due to the server restarting.", function () { return vueApp.waitForUpdate(); });
                    }
                };
                xhr.responseType = 'json';
                xhr.send();
            };
            ui_update_timeout_id = window.setTimeout(askForUpdate, this.waitingForTimeout);
        },
    },
    render: function (createElement) {
        var _this = this;
        document.title = i18n_1.$t(constants.APP_NAME);
        window.clearInterval(documentTitleTimer);
        if (this.waitingfor === undefined) {
            this.waitForUpdate();
            return createElement('div', i18n_1.$t('Not your turn to take any actions'));
        }
        if (this.player.players.length > 1 && this.player.waitingFor !== undefined) {
            documentTitleTimer = window.setInterval(function () { return _this.animateTitle(); }, 1000);
        }
        var input = new PlayerInputFactory_1.PlayerInputFactory().getPlayerInput(createElement, this.players, this.player, this.waitingfor, function (out) {
            var xhr = new XMLHttpRequest();
            var root = _this.$root;
            var showAlert = _this.$root.showAlert;
            if (root.isServerSideRequestInProgress) {
                console.warn('Server request in progress');
                return;
            }
            root.isServerSideRequestInProgress = true;
            xhr.open('POST', '/player/input?id=' + _this.player.id);
            xhr.responseType = 'json';
            xhr.onload = function () {
                if (xhr.status === 200) {
                    root.screen = 'empty';
                    root.player = xhr.response;
                    root.playerkey++;
                    root.screen = 'player-home';
                    if (_this.player.game.phase === 'end' && window.location.pathname !== '/the-end') {
                        (window).location = (window).location;
                    }
                }
                else if (xhr.status === 400 && xhr.responseType === 'json') {
                    showAlert(xhr.response.message);
                }
                else {
                    showAlert('Unexpected response from server. Please try again.');
                }
                root.isServerSideRequestInProgress = false;
            };
            xhr.send(JSON.stringify(out));
            xhr.onerror = function () {
                root.isServerSideRequestInProgress = false;
            };
        }, true, true);
        return createElement('div', { 'class': 'wf-root' }, [input]);
    },
});
//# sourceMappingURL=WaitingFor.js.map